import { render } from "./ContractEditComponent.vue?vue&type=template&id=4cf95517"
import script from "./ContractEditComponent.vue?vue&type=script&lang=js"
export * from "./ContractEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__